module.exports = __webpack_public_path__ + "static/img/2-1.979b4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2-1.png
// module id = RaZH
// module chunks = 15